import {
  menuIconClasses,
  menuPopupClasses,
  menuPositionerClasses,
  menuTriggerClasses,
} from "./Menu.style";

import * as React from "react";

import { Menu as BaseMenu } from "@base-ui-components/react/menu";
import { ChevronDownIcon } from "@spoctech/icons";

type MenuProps<T extends React.ElementType = "button"> = Pick<
  React.ComponentProps<typeof BaseMenu.Positioner>,
  "align"
> & {
  label?: React.ReactNode;
  component?: T; // Accepts any React component or HTML tag
} & React.ComponentProps<typeof BaseMenu.Root> &
  React.ComponentPropsWithoutRef<T>; // Allows passing extra props for the component

const Menu = <T extends React.ElementType = "button">(props: MenuProps<T>) => {
  const {
    children,
    className,
    label,
    component: Component = "button",
    title,
    align,
    ...rest
  } = props;

  return (
    <BaseMenu.Root {...rest}>
      <BaseMenu.Trigger
        type="button"
        className={menuTriggerClasses({ className: className })}
        title={title}
      >
        {label} <ChevronDownIcon className={menuIconClasses()} />
      </BaseMenu.Trigger>
      <BaseMenu.Portal>
        <BaseMenu.Positioner
          align={align}
          className={menuPositionerClasses()}
          sideOffset={8}
          sticky
        >
          <BaseMenu.Popup className={menuPopupClasses()}>
            {children}
          </BaseMenu.Popup>
        </BaseMenu.Positioner>
      </BaseMenu.Portal>
    </BaseMenu.Root>
  );
};

export default Menu;
